<template>
  <div class="audio-progress">
    <template v-if="mode === 1">
      <div v-if="showCurrentTime" class="current-time" v-text="currentTimeAfterFormat">0:59</div>
      <div ref="audio-player" class="audio-player">
        <div ref="audioProgressWrap" class="audio__progress-wrap" @click.stop="initProgressBarPoint">
          <div ref="audioProgress" class="audio__progress" />
          <div ref="audioProgressPoint" class="audio__progress-point" />
        </div>
      </div>
      <div class="duration-time" v-text="durationFormat">2:00</div>
    </template>
    <template v-if="mode === 2">
      <div ref="audio-player" class="audio-player mode-2">
        <div ref="audioProgressWrap" class="audio__progress-wrap" @click.stop="initProgressBarPoint">
          <div ref="audioProgress" class="audio__progress" />
          <div ref="audioProgressPoint" class="audio__progress-point" />
        </div>
      </div>
      <div v-if="showCurrentTime" class="current-time mode-2" v-text="currentTimeAfterFormat">0:59</div>
      <div style="margin: 0 4px; font-size: 12px">/</div>
      <div class="duration-time" v-text="durationFormat">2:00</div>
    </template>
    <audio
      ref="audio"
      class="audio-player__audio"
      :src="audioUrl"
      @play="onplay"
      @ended="onEnded"
      @loadedmetadata="onLoadedmetadata"
      @timeupdate="ontimeupdate"
    />
  </div>
</template>

<script>
import { formatDuration } from '@/utils'

export default {
  name: 'AudioProgress',
  props: {
    audioUrl: {
      type: String,
      required: true
    },
    isPlaying: {
      type: Boolean,
      default: () => false
    },
    speed: {
      type: Number,
      default: () => 1
    },
    showCurrentTime: {
      type: Boolean,
      default: () => true
    },
    // 样式类型 1默认的 2悬浮在按钮上面的
    mode: {
      type: Number,
      default: () => 1
    },
    playbackRate: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      timer: null,
      currentTime: 0, // 音频当前播放时间
      currentTimeAfterFormat: 0, // 音频播放当时时间（格式化后）
      duration: 0, // 音频持续时间
      durationFormat: 0, // 音频播放当时时间（格式化后）
      playEnded: false
    }
  },
  watch: {
    isPlaying(val) {
      if (val) {
        this.play()
      } else {
        this.pause()
      }
    },
    audioUrl(val, old) {
      if (val !== old) {
        this.defaultPoint()
      }
    },
    speed(val) {
      if (this.$refs.audio) {
        // 设置音频的播放速度
        this.$refs.audio.playbackRate = val
      }
    },
    playbackRate(val) {
      if (val) {
        this.$refs.audio.playbackRate = this.playbackRate
      }
    }
  },
  destroyed() {
    this.pause()
    this.currentTime = 0
    this.duration = 0
  },
  mounted() {
    if (this.$refs.audio) {
      // 设置音频的播放速度
      this.$refs.audio.playbackRate = this.speed
    }
  },
  methods: {
    // 当媒介元素的持续时间以及其它媒介已加载数据时运行脚本
    onLoadedmetadata() {
      this.durationFormat = formatDuration(this.$refs.audio.duration)
      this.duration = this.$refs.audio.duration
      this.defaultPoint()
    },
    onplay() {
      this.playEnded = false
    },
    // 音频播放完毕
    onEnded() {
      this.pause()
      this.$refs.audio.currentTime = 0
      this.currentTimeAfterFormat = formatDuration(this.$refs.audio.currentTime)
      this.$refs.audioProgress.style.width = '0'
      this.$refs.audioProgressPoint.style.left = '0'
      this.$emit('onEnded')
    },
    // 设置点点位置
    setPointPosition(pageX) {
      // 设置点点
      this.$refs.audioProgressPoint.style.left =
        pageX - this.$refs.audioProgressPoint.offsetWidth / 2 - this.$refs.audioProgressWrap.offsetLeft + 'px'
    },
    // 初始化音频进度的点击逻辑
    initProgressBarPoint(event) {
      if (!this.audioUrl) return
      event.stopPropagation()
      const width = event.offsetX + this.$refs.audioProgressWrap.offsetLeft
      // 处理左侧越界
      // if (width <= this.$refs.audioProgressWrap.offsetLeft) {
      //   width = this.$refs.audioProgressWrap.offsetLeft
      // }
      // 处理右侧越界
      // if (width >= this.$refs.audioProgressWrap.offsetLeft + this.$refs.audioProgressWrap.offsetWidth) {
      //   width = this.$refs.audioProgressWrap.offsetLeft + this.$refs.audioProgressWrap.offsetWidth
      // }
      // 设置当前时间
      this.currentTime =
        ((width - this.$refs.audioProgressWrap.offsetLeft) / this.$refs.audioProgressWrap.offsetWidth) *
        this.$refs.audio.duration
      // 设置播放位置
      this.$refs.audio.currentTime = this.currentTime
      this.setPointPosition(width)
      // 设置进度条
      this.$refs.audioProgress.style.width = width - this.$refs.audioProgressWrap.offsetLeft + 'px'
      // 设置当前时间（格式化后）
      this.currentTimeAfterFormat = formatDuration(this.currentTime)
    },
    // 当媒介改变其播放位置时运行脚本
    ontimeupdate(val) {
      // 当音频播放状态为播放结束时，不再对外发送播放位置信息
      if (this.playEnded) return
      if (val.target.currentTime === val.target.duration) {
        this.playEnded = true
      }
      this.$emit('ontimeupdate', val.target.currentTime, val.target.duration, this.playEnded)
    },
    // 播放中
    playing() {
      if (!this.$refs.audio) return
      this.currentTimeAfterFormat = formatDuration(this.$refs.audio.currentTime)
      // 设置播放进度条
      this.$refs.audioProgress.style.width =
        (this.$refs.audio.currentTime / this.$refs.audio.duration) * this.$refs.audioProgressWrap.offsetWidth + 'px'
      // 设置播放进度拖拽点
      this.$refs.audioProgressPoint.style.left =
        (this.$refs.audio.currentTime / this.$refs.audio.duration) * this.$refs.audioProgressWrap.offsetWidth -
        this.$refs.audioProgressPoint.offsetWidth / 2 +
        'px'
    },
    defaultPoint() {
      this.currentTimeAfterFormat = '0:00'
      // 设置播放进度条
      this.$refs.audioProgress.style.width = 0 + 'px'
      // 设置播放进度拖拽点
      this.$refs.audioProgressPoint.style.left = 0 + 'px'
    },
    // 开始播放
    play() {
      if (!this.audioUrl) return
      const playHandler = () => {
        this.$refs.audio.play()
        this.$nextTick(() => {
          this.playing()
          this.timer = setInterval(this.playing, 100)
          this.$emit('changePlaying', true)
        })
      }
      playHandler()
    },
    // 暂停播放
    pause() {
      if (!this.audioUrl) return
      if (this.$refs.audio) {
        this.$refs.audio.pause()
      }
      this.$nextTick(() => {
        clearInterval(this.timer)
        this.$emit('changePlaying', false)
      })
    },
    // 变更音频播放位置 -- 外界调用
    changeCurrentTime(currentTime) {
      this.$refs.audio.currentTime = currentTime
    }
  }
}
</script>

<style lang="scss" scoped>
.audio-progress {
  display: flex;
  align-items: center;

  .current-time,
  .duration-time {
    font-size: 12px;
    font-weight: 400;
    color: #333333;
  }

  .current-time {
    &.mode-2 {
      color: #1976ff;
    }
  }

  .audio-player {
    width: 150px;
    margin: 0 15px;

    &.mode-2 {
      width: 120px;

      .audio__progress-wrap {
        height: 6px;
        border-radius: 17px;

        .audio__progress {
          border-radius: 17px;
        }

        .audio__progress-point {
          width: 20px;
          height: 20px;
          background: linear-gradient(270deg, #66adff 0%, #1976ff 100%);
          box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.2);
          border: 1px solid #ffffff;
          margin-top: -7px;
        }
      }
    }

    .audio__progress-wrap {
      position: relative;
      background: #ddd;
      height: 4px;
      border-radius: 4px;
      cursor: pointer;
      transition: all 0.05s;

      .audio__progress {
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 0;
        border-radius: 4px;
        background: #1976ff;
        transition: all 0.05s;
      }

      .audio__progress-point {
        width: 14px;
        height: 14px;
        position: absolute;
        left: 0;
        z-index: 3;
        margin-top: -5px;
        margin-left: -5px;
        border-radius: 50%;
        background: #1976ff;
        transition: all 0.05s;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }

    .audio-player__audio {
      display: block;
      margin: 0 auto;
    }
  }
}
</style>
